// src/services/tokenService.js
import apiClient from './apiClient';

export const listTokens = async () => {
    const response = await apiClient.get('/auth/tokens');

    if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || 'Failed to load API tokens');
    }

    return await response.json();
};

export const createToken = async ({ name, expiresInDays }) => {
    const response = await apiClient.post('/auth/tokens', { name, expiresInDays });

    if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || 'Failed to create API token');
    }

    return await response.json();
};

export const revokeToken = async (id) => {
    const response = await apiClient.delete(`/auth/tokens/${id}`);

    if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || 'Failed to revoke API token');
    }

    return await response.json();
};

export const regenerateToken = async (id) => {
    const response = await apiClient.post(`/auth/tokens/${id}/regenerate`, {});

    if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || 'Failed to regenerate API token');
    }

    return await response.json();
};
